import React from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';

import MobileTrackRow from './mobile-row/track-row';
import DesktopTrackRow from './desktop-view/track-row';
import { ReleaseStatus } from '@common/types/release/relase-status';
import CatalogTrack from '@common/types/catalog/catalog-track';

export interface Artist {
  id: string;
  name: string;
  avatar?: string;
}

declare type CatalogTrackRowProps = {
  track: CatalogTrack;
  releaseStatus: ReleaseStatus;
  isReleases: boolean;
  isMobile: boolean;
  isArtist?: boolean;
  artistId?: string;
};

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

export default connect(mapStateToProps)(function CatalogTrackRow({
  track,
  releaseStatus,
  isReleases,
  isMobile,
  isArtist,
  artistId,
}: CatalogTrackRowProps) {
  return isMobile ? (
    <MobileTrackRow
      releaseStatus={releaseStatus}
      track={track}
      isReleases={isReleases}
      isArtist={isArtist}
      artistId={artistId}
    />
  ) : (
    <DesktopTrackRow
      releaseStatus={releaseStatus}
      track={track}
      isReleases={isReleases}
      isArtist={isArtist}
      artistId={artistId}
    />
  );
});
